import { render } from "./product_id.vue?vue&type=template&id=1e313528"
import script from "./product_id.vue?vue&type=script&lang=js"
export * from "./product_id.vue?vue&type=script&lang=js"

import "./product_id.vue?vue&type=style&index=0&id=1e313528&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__